import * as FlightsFilterActions from '../actions/flights-filter.actions';
import * as FlightsFilterState from '../states/flights-filter.state';

export class State extends FlightsFilterState.State { }

const initialState: FlightsFilterState.State = FlightsFilterState.initialState;

/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {FlightsFilterActions.Actions} action
 * @returns {FlightsFilterState.State}
 */
export function reducer(state = initialState, action: FlightsFilterActions.Actions): FlightsFilterState.State {

	switch (action.type) {
		case FlightsFilterActions.ActionTypes.PUT_DIRECT_FLIGHT:
			state = Object.assign({}, state, { directFlights: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_CABIN_OPTIONS:
			state = Object.assign({}, state, { cabinOptions: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_BAGGAGE_INCLUDED:
			state = Object.assign({}, state, { baggageIncluded: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_ONLY_REFUNDABLE:
			state = Object.assign({}, state, { onlyRefundable: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_SCHEDULE:
			state = Object.assign({}, state, { schedule: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_AIRLINE:
			state = Object.assign({}, state, { airline: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_AIRLINES:
			state = Object.assign({}, state, { airlines: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_TYPE_STUDENT:
			state = Object.assign({}, state, { student: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_TYPE_LIVE_AZORES_MADEIRA:
			state = Object.assign({}, state, { live_azores_madeira: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_FLIGHT_WITH_MILES:
			state = Object.assign({}, state, { flightWithMiles: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_BOOK_AWARD_FLIGHTS:
			state = Object.assign({}, state, { loading: false, bookAwardFlights: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_STAR_ALLIANCE_FLIGHTS:
			state = Object.assign({}, state, { loading: false, starAlliance: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.PUT_PAY_WITH_MILES_EDITABLE_STATE:
			state = Object.assign({}, state, { loading: false, payWithMilesEditableState: action.payload });
			return state;
		case FlightsFilterActions.ActionTypes.RESET_ADVANCE_SEARCH_FILTERS:
			state = Object.assign({}, state, {
				directFlights: initialState.directFlights,
				cabinOptions: initialState.cabinOptions,
				baggageIncluded: initialState.baggageIncluded,
				onlyRefundable: initialState.onlyRefundable,
				schedule: initialState.schedule,
				airline: initialState.airline,
				airlines: initialState.airlines,
				live_azores_madeira: initialState.live_azores_madeira,
				student: initialState.student
			});
			return state;
		case FlightsFilterActions.ActionTypes.RESET:
			state = Object.assign({}, state, {
				directFlights: initialState.directFlights,
				cabinOptions: initialState.cabinOptions,
				baggageIncluded: initialState.baggageIncluded,
				onlyRefundable: initialState.onlyRefundable,
				schedule: initialState.schedule,
				airline: initialState.airline,
				airlines: initialState.airlines,
				starAlliance: initialState.starAlliance,
				live_azores_madeira: initialState.live_azores_madeira,
				payWithMilesEditableState: initialState.payWithMilesEditableState,
				student: initialState.student,
				flightWithMiles: initialState.flightWithMiles
			});
			return state;
		case FlightsFilterActions.ActionTypes.RESET_BOOKAWARDFLIGHTS:
			state = Object.assign({}, state, {
				bookAwardFlights: initialState.bookAwardFlights,
			});
			return state;
		default:
			return state;
	}
}

export const getDirectFlights = (state: FlightsFilterState.State) => state.directFlights;
export const getCabinOptions = (state: FlightsFilterState.State) => state.cabinOptions;
export const getBaggageIncluded = (state: FlightsFilterState.State) => state.baggageIncluded;
export const getOnlyRefundable = (state: FlightsFilterState.State) => state.onlyRefundable;
export const getSchedule = (state: FlightsFilterState.State) => state.schedule;
export const getAirline = (state: FlightsFilterState.State) => state.airline;
export const getAirlines = (state: FlightsFilterState.State) => state.airlines;
export const getStudent = (state: FlightsFilterState.State) => state.student;
export const getLiveAzoresMadeira = (state: FlightsFilterState.State) => state.live_azores_madeira;
export const getFlightWithMiles = (state: FlightsFilterState.State) => state.flightWithMiles;
export const getBookAwardFlights = (state: FlightsFilterState.State) => state.bookAwardFlights;
export const getPayWithMilesEditableState = (state: FlightsFilterState.State) => state.payWithMilesEditableState;
export const getStarAllianceFlights = (state: FlightsFilterState.State) => state.starAlliance;

export const countActiveItems = (state: FlightsFilterState.State) => {
	let count = 0;
	if (state.directFlights) {
		count++;
	}

	// change all to E
	if (state.cabinOptions !== 'E') {
		count++;
	}
	if (state.baggageIncluded) {
		count++;
	}
	if (state.onlyRefundable) {
		count++;
	}
	if (state.airline) {
		count++;
	}
	if (state.airlines.length) {
		count++;
	}
	if (state.student) {
		count++;
	}
	if (typeof state.live_azores_madeira != 'string') {
		if (state.live_azores_madeira) {
			count++;
		}
	}
	if (state.schedule) {
		if (state.schedule.length > 0) {
			const tmp = state.schedule;
			for (let i = 0; i < tmp.length; i++) {
				if (tmp[i].departure)
					count++;
				if (tmp[i].arrival)
					count++;
			}
		}
	}
	return count;
};

